import React from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { mockBlogs } from "./Blog";

const BlogDetail = () => {
  const { id } = useParams();
  const blog = mockBlogs.find(b => b.id === parseInt(id));

  if (!blog) {
    return (
      <div className="min-h-[50vh] flex flex-col items-center justify-center text-center p-4">
        <h2 className="text-3xl font-bold text-gray-800 mb-2">ब्लॉग नहीं मिला</h2>
        <p className="text-gray-500 mb-6">आप जो ब्लॉग ढूंढ रहे हैं वह मौजूद नहीं है।</p>
        <Link to="/blog" className="bg-purple-700 text-white px-6 py-2 rounded-full font-bold hover:text-brand-red transition-colors">
          ब्लॉग्स पर वापस जाएं
        </Link>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen py-10">
      <Helmet>
        <title>{blog.title} | मंदाकिनी टाइम्स</title>
        <meta name="description" content={blog.excerpt} />
      </Helmet>

      <div className="max-w-4xl mx-auto px-4">
        {/* Back button */}
        <Link to="/blog" className="inline-flex items-center text-purple-600 hover:text-red-700 font-bold mb-6 transition-colors">
          <i className="fa-solid fa-arrow-left mr-2"></i> ब्लॉग्स पर वापस जाएं
        </Link>

        {/* Article Container */}
        <article className="bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden">
          
          {/* Header Image */}
          <div className="w-full h-[300px] md:h-[400px] bg-gray-200 relative">
            <img 
              src={blog.image || 'https://images.unsplash.com/photo-1585829365295-ab7cd400c167?auto=format&fit=crop&q=80&w=1200&h=600'} 
              alt={blog.title} 
              className="w-full h-full object-cover"
              onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1585829365295-ab7cd400c167?auto=format&fit=crop&q=80&w=1200&h=600' }}
            />
          </div>

          <div className="p-8 md:p-12">
            <h1 className="text-3xl md:text-5xl font-black text-gray-900 leading-tight mb-6">
              {blog.title}
            </h1>

            <div className="flex flex-wrap items-center justify-between gap-4 py-6 border-y border-gray-100 mb-8">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center text-xl font-bold text-gray-600">
                  {blog.author.charAt(0)}
                </div>
                <div>
                  <p className="text-base font-bold text-gray-900">{blog.author}</p>
                  <p className="text-sm text-gray-500">{blog.date}</p>
                </div>
              </div>
              <div className="flex items-center gap-4 text-sm font-medium text-gray-500">
                <span><i className="fa-regular fa-clock mr-1"></i>{blog.readTime}</span>
                
                {/* Social Share (Static) */}
                <div className="flex items-center gap-2 ml-4 border-l border-gray-200 pl-4">
                  <span className="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center text-gray-600 hover:bg-purple-50 hover:text-brand-red cursor-pointer transition-colors"><i className="fa-brands fa-twitter"></i></span>
                  <span className="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center text-gray-600 hover:bg-blue-50 hover:text-blue-600 cursor-pointer transition-colors"><i className="fa-brands fa-facebook-f"></i></span>
                  <span className="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center text-gray-600 hover:bg-green-50 hover:text-green-600 cursor-pointer transition-colors"><i className="fa-brands fa-whatsapp"></i></span>
                </div>
              </div>
            </div>

            <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed text-justify">
              <p className="text-xl text-gray-600 font-medium italic mb-8 border-l-4 border-red-500 pl-4">
                {blog.excerpt}
              </p>
              
              <p>
                {blog.content}
              </p>

              {/* Just repeating content for dummy effect to make it look like a real article */}
              <p className="mt-6">
                जैसे-जैसे अधिक रिपोर्ट आ रही हैं, यह स्पष्ट है कि अगले कुछ वर्षों में इस प्रवृत्ति में और तेजी आएगी। जमीनी स्तर की भागीदारी और उच्च-स्तरीय नीति निर्माण का संयोजन एक अद्वितीय पारिस्थितिकी तंत्र बनाता है।
              </p>
              
              <h3 className="text-2xl font-bold text-gray-900 mt-10 mb-4">व्यापक प्रभाव</h3>
              <p>
                विशेषज्ञों का अनुमान है कि इन परिवर्तनों का पड़ोसी जिलों में व्यापक प्रभाव पड़ेगा, जो संभावित रूप से विकास के लिए एक नया मानक स्थापित करेगा। यह देखना बाकी है कि केंद्रीय प्रशासन कैसे प्रतिक्रिया देगा, लेकिन शुरुआती संकेत बहुत आशाजनक हैं।
              </p>
            </div>
          </div>
        </article>
      </div>
    </div>
  );
};

export default BlogDetail;
